import ModalsOnboarding from 'app/developer-v3/components/ModalsOnboarding';

import Invite from './Invite';

export default {
  Invite,
  OnboardNewDev: ModalsOnboarding.NewDev,
  OnboardExistingDev: ModalsOnboarding.ExistingDev,
};
